export default __webpack_public_path__ + "static/media/study.a36e261a.svg";